'use strict';

function emitus (api) {
  if ( api === void 0 ) api = {};

  var events = {};

  return Object.assign(
    {
      on: function on (type, fn) {
        (events[type] || (events[type] = [])).push(fn);
      },
      off: function off (type, fn) {
        if ( fn === void 0 ) fn = null;

        if (events[type]) {
          events[type].splice(events[type].indexOf(fn), 1);
        }
      },
      emit: function emit (type, args) {
        var this$1 = this;
        if ( args === void 0 ) args = [];

        (events[type] || []).map(function (fn) {
          if (fn && typeof fn === 'function') { fn.apply(this$1, args); }
        });
      }
    },
    api
  )
}

module.exports = emitus;
//# sourceMappingURL=emitus.js.map
